const accessibilityMenu = document.querySelector('#header .accessibility-menu') as HTMLElement;
const accessibilityLinkMobile = document.querySelector('#header .accessibility-link-mobile, #header .accessibility-link-shared') as HTMLAnchorElement;
const accessibilityLinkDesktop = document.querySelector('#header .accessibility-link-desktop, #header .accessibility-link-shared') as HTMLAnchorElement;
const accessibilityMenuFooter = accessibilityMenu?.querySelector('.accessibility-menu_footer') as HTMLElement;

if (accessibilityLinkMobile && accessibilityLinkDesktop && accessibilityMenu) {
  // Store and handle focus settings
  const navigation = document.querySelector('#header .navigation') as HTMLElement;
  const mediaQuery = window.matchMedia('(min-width: 992px)');
  const focsusSwitch = accessibilityMenu.querySelector('.switch input[name="focus"]') as HTMLInputElement;
  const menuLinks = accessibilityMenu.querySelectorAll('a') as NodeListOf<HTMLAnchorElement>;
  const jumpToNavigationLink = accessibilityMenu.querySelector('ul:not(:first-child) li') as HTMLAnchorElement;
  let focusEnabled = false;
  let elemMenuOpenedFrom: HTMLElement | null = null;

  try {
    focusEnabled = localStorage.getItem('focus') === 'true';
  } catch (error) {
    focusEnabled = false;
  }

  if (navigator.userAgent.indexOf('Mac') != -1) {
    accessibilityMenuFooter?.querySelector('.mac')?.classList.remove('is-hidden');
    accessibilityMenuFooter?.querySelector('.windows')?.classList.add('is-hidden');
  }

  // Handle focus switch
  focsusSwitch.checked = focusEnabled;
  document.body.classList.toggle('tab-navigation-active', focusEnabled);
  focsusSwitch.addEventListener('change', () => {
    localStorage.setItem('focus', focsusSwitch.checked.toString());
    document.body.classList.toggle('tab-navigation-active', focsusSwitch.checked);

    if (mediaQuery.matches) {
      setDesktopPosition();
    }

    if (focsusSwitch.checked) {
      focsusSwitch.focus();
    }
  });

  // Handle open and close
  (accessibilityLinkDesktop === accessibilityLinkMobile ? [accessibilityLinkMobile] : [accessibilityLinkMobile, accessibilityLinkDesktop]).forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      toggleAccessibilityMenu(e);
    });
  });

  // Close
  const closeButton = accessibilityMenu.querySelector('.close') as HTMLButtonElement;
  closeButton.addEventListener('click', () => {
    accessibilityMenu.classList.remove('is-open');
    elemMenuOpenedFrom?.focus();
    removeCloseOutsideClickHandler();
  });

  menuLinks.forEach(link => {
    link.addEventListener('click', () => {
      accessibilityMenu.classList.remove('is-open');
      removeCloseOutsideClickHandler();
    });
  });

  jumpToNavigationLink.addEventListener('click', e => {
    e.preventDefault();
    if (mediaQuery.matches) {
      accessibilityLinkDesktop.focus();
    } else {
      window.dispatchEvent(openMobileMenu);
      setTimeout(() => {
        accessibilityLinkMobile.focus();
      }, 750);
    }
    accessibilityMenu.classList.remove('is-open');
    removeCloseOutsideClickHandler();
  });

  function setCloseOutsideClickHandler() {
    document.addEventListener('click', handleDocumentClick);
  }

  function removeCloseOutsideClickHandler() {
    document.removeEventListener('click', handleDocumentClick);
  }

  function handleDocumentClick(event: MouseEvent) {
    clickOutsideMenu(event);
  }

  function clickOutsideMenu(event: MouseEvent) {
    if (accessibilityMenu.classList.contains('is-open') && event.target && !(event.target as HTMLElement).closest('.accessibility-menu')) {
      accessibilityMenu.classList.remove('is-open');
      removeCloseOutsideClickHandler();
    }
  }

  // Set menu desktop position
  function setDesktopPosition() {
    const navigationRect = navigation.getBoundingClientRect();
    const linkRect = accessibilityLinkDesktop.getBoundingClientRect();
    const offsetLeft = linkRect.left - (window.innerWidth - navigationRect.width) / 2 + accessibilityLinkDesktop.offsetWidth / 2 - accessibilityMenu.offsetWidth / 2;
    accessibilityMenu.style.left = offsetLeft + accessibilityMenu.offsetWidth + (window.innerWidth - navigationRect.width) / 2 > window.innerWidth ? 'unset' : `${offsetLeft}px`;
  }

  if (mediaQuery.matches) {
    setDesktopPosition();
  }

  // Get element that was currently focused to allow moving focus back
  function setOpenedFromElement() {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement) {
      elemMenuOpenedFrom = activeElement;
      jumpToNavigationLink.classList.toggle('is-hidden', elemMenuOpenedFrom === accessibilityLinkDesktop || elemMenuOpenedFrom === accessibilityLinkMobile);
    }
  }

  function toggleAccessibilityMenu(e?: Event) {
    e?.preventDefault();
    e?.stopPropagation();
    accessibilityMenu.classList.toggle('is-open');
    if (accessibilityMenu.classList.contains('is-open')) {
      window.dispatchEvent(showHeader);
      setOpenedFromElement();
      closeButton.focus();
      setCloseOutsideClickHandler();
    } else {
      elemMenuOpenedFrom?.focus();
      removeCloseOutsideClickHandler();
    }
  }

  // Event listener to open the menu any time with keyboard
  document.addEventListener('keydown', event => {
    if ((event.altKey && (event.code === 'KeyA' || (event.shiftKey && event.code === 'KeyS'))) || (event.ctrlKey && (event.code === 'KeyS' || (event.shiftKey && event.code === 'KeyL')))) {
      if (!focsusSwitch.checked && !accessibilityMenu.classList.contains('is-open')) {
        focsusSwitch.checked = true;
        localStorage.setItem('focus', 'true');
        document.body.classList.add('tab-navigation-active');
      }
      toggleAccessibilityMenu();
    }
  });

  // Custom events to toggle mobile navigation and header
  const openMobileMenu = new Event('openMenuMobile');
  const showHeader = new Event('showHeaderForLink');
}
